/* tslint:disable:max-line-length */
import { Component } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Outlet } from 'react-router';
import { InStreamVideoEligibilityProvider } from '../../../../../shared/frontend/components/ads/instreamVideoContext';
import { VideoPlacementProviders } from '../../../../../shared/frontend/components/ads/videoPlacementProviders';
import { MediaContextProvider } from '../../../../../shared/frontend/components/presentational/media';

export default class RootNode extends Component<any, any> {
  public render() {
    return (
      <>
        <Helmet defaultTitle="World of Warcraft Character & Guild Rankings, Server & Realm Details, and Recruitment">
          <meta property="og:url" content={RIO_SITE.external_url} />
          <meta property="og:image" content={`http://${RIO_SITE.cdn_host}/images/fb_app_image.jpg`} />
          <meta
            property="og:title"
            content="World of Warcraft Character & Guild Rankings, Server & Realm Details, and Recruitment"
          />
          <meta property="og:type" content="website" />
          <meta
            name="description"
            content="Raider.IO is a World of Warcraft (WoW) Stats and Rankings site! You can follow the race to Hardcore Level 60 for every class, view details about your Characters, Guilds, Realms, and much more. Use our Recruitment system to recruit players or find a new guild! We're excited to be able to start bringing more features to the WoW Classic scene!
"
          />
          <meta
            property="og:description"
            content="Raider.IO is a World of Warcraft (WoW) Stats and Rankings site! You can follow the race to Hardcore Level 60 for every class, view details about your Characters, Guilds, Realms, and much more. Use our Recruitment system to recruit players or find a new guild! We're excited to be able to start bringing more features to the WoW Classic scene!
"
          />
          <meta property="twitter:image" content={`http://${RIO_SITE.cdn_host}/images/fb_app_image.jpg`} />
          <meta property="twitter:card" content="summary" />
          <meta property="theme-color" content="#ffbd0a" />
        </Helmet>
        <MediaContextProvider>
          <InStreamVideoEligibilityProvider>
            <VideoPlacementProviders>{this.props.children || <Outlet />}</VideoPlacementProviders>
          </InStreamVideoEligibilityProvider>
        </MediaContextProvider>
      </>
    );
  }
}
